import { useTheme } from "@mui/material";
import { TierCardWrapper } from "@src/appV2/redesign/Tiers/Cards/TierCardWrapper";
import { TIERS_CARD_IMAGE_SIZE } from "@src/appV2/redesign/Tiers/utils/constants";
// eslint-disable-next-line no-restricted-imports
import GoldTrophy from "@src/assets/images/goldTrophy.png";

export function GoldTierCardWrapper(props: { children: React.ReactNode }) {
  const { children } = props;
  const theme = useTheme();

  return (
    <TierCardWrapper
      image={GoldTrophy}
      imageSize={TIERS_CARD_IMAGE_SIZE}
      background={theme.palette.tiers?.gold?.background}
      transform="rotate(20deg)"
    >
      {children}
    </TierCardWrapper>
  );
}
